import { Box, Typography } from '@mui/material';
import ProductAdditionalItems from './ProductAdditionalItems';
import ProductAdditionalProducts from './ProductAdditionalProducts';
import ProductSubstitutes from './ProductSubstitutes';
import useProductAddonsSWR from 'hooks/products/useProductAddonsSWR';
import { ErrorTypography } from 'components/styled/ErrorTypography';
import { Spinner } from 'components/shared/Spinner';
import { useTranslation } from 'react-i18next';

const ProductConnectedProducts: React.FC<ProductConnectedProductsProps> = (
    props
) => {
    const { t } = useTranslation('product', {
        keyPrefix: 'PRODUCT.TABS.ADDONS',
    });

    const { productAddons, isLoading, isError } = useProductAddonsSWR(
        props.productId
    );

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Spinner />
            </Box>
        );
    }

    if (isError && !isLoading) {
        return <ErrorTypography errorCode={'GLOBAL_ERROR'} />;
    }

    if (
        !isLoading &&
        productAddons.additional_items.length === 0 &&
        productAddons.additional_products.length === 0 &&
        productAddons.substitutes.length === 0
    ) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Typography>{t('NO_PRODUCTS').toString()}</Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '48px',
            }}
        >
            {productAddons && productAddons.additional_items.length > 0 && (
                <ProductAdditionalItems
                    additionalItems={productAddons.additional_items}
                />
            )}
            {productAddons && productAddons.additional_products.length > 0 && (
                <ProductAdditionalProducts
                    additionalProducts={productAddons.additional_products}
                />
            )}
            {productAddons && productAddons.substitutes.length > 0 && (
                <ProductSubstitutes substitutes={productAddons.substitutes} />
            )}
        </Box>
    );
};

export default ProductConnectedProducts;

type ProductConnectedProductsProps = {
    productId: string;
    collectionHandle: string;
};
